import { User } from '@/types/admin';
type EntityUserProps = {
  user: User;
  removeUser: (email: string) => Promise<void>;
};
function EntityUser({ user, removeUser }: EntityUserProps) {
  return (
    <tr key={user.email} className='odd:bg-white  even:bg-gray-50 border-b'>
      <th scope='row' className='px-6 py-4 font-medium text-gray-900 whitespace-nowrap '>
        {user.email}
      </th>
      <td className='px-6 py-4'>
        {user.roles.map((role) => (
          <span
            key={role}
            className='py-1 px-2 shadow-md no-underline rounded-full bg-orange-500 font-semibold text-sm border-orange btn-primary text-white hover:bg-orange-300 focus:outline-none active:shadow-none mr-2'
          >
            {role}
          </span>
        ))}
      </td>
      <td className='px-6 py-4'>{user.invitedBy ?? '-'}</td>
      <td className='px-6 py-4'>{user.invitedAt?.toLocaleDateString() ?? '-'}</td>
      <td className='px-6 py-4'>{user.accepted ? 'yes' : 'no'}</td>
      <td className='px-6 py-4'>{user.acceptedAt?.toLocaleDateString() ?? '-'}</td>
      <td>
        <button
          className='py-1 px-2 shadow-md no-underline rounded-full bg-red-500 hover:bg-red-400'
          onClick={() => removeUser(user.email)}
        >
          <svg
            className='text-white w-4 h-4 mx-auto'
            aria-hidden='true'
            fill='currentColor'
            viewBox='0 0 20 20'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              fillRule='evenodd'
              d='M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z'
              clipRule='evenodd'
            ></path>
          </svg>
        </button>
      </td>
    </tr>
  );
}

export default EntityUser;
